import React from 'react';
import { Button, Dropdown, Form, Modal } from 'semantic-ui-react';
import { TextField } from '../../common/FormFields';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import * as selectors from '../../../redux/selectors';
import * as actions from '../../../redux/actions';
import * as api from '../../../api/postApi';
import * as yup from 'yup';
import { bindActionCreators } from 'redux';

const AddEventModal = ({ sites, getSites, addNewsItem }) => {
  const [open, setOpen] = React.useState(false);

  const getEventDetailSection = async siteId => {
    const { sections } = await api.getSections(siteId);
    const { id } = sections?.find(section => section?.title?.includes('eventdetail'));
    return id;
  };

  const validationSchema = yup.object({
    siteId: yup.string().required('A site is required'),
    headline: yup.string().required('An event title is required'),
  });

  const handleSubmit = async (post, formik) => {
    const sectionId = await getEventDetailSection(post.siteId);
    addNewsItem({ ...post, type: 'event', sectionId });
    setOpen(false);
    formik.resetForm();
  };

  return (
    <Formik
      initialValues={{ siteId: '', sectionId: '', headline: '' }}
      enableReinitialize
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {formik => (
        <Modal
          size="small"
          onClose={() => setOpen(false)}
          onOpen={() => setOpen(true)}
          open={open}
          trigger={<Button icon="plus" labelPosition="left" positive content="Add Event" />}
        >
          <Modal.Header>Add Event</Modal.Header>
          <Modal.Content>
            <Form onSubmit={formik.handleSubmit} widths="equal">
              <Form.Group>
                <Form.Field>
                  <strong>City</strong>
                  <Dropdown
                    fluid
                    search
                    selection
                    clearable
                    options={sites || []}
                    id="siteId"
                    label="Site"
                    name="siteId"
                    value={formik.values.siteId}
                    onChange={(e, { name, value }) => formik.setFieldValue(name, value)}
                    size="small"
                  />
                </Form.Field>
              </Form.Group>
              <strong>Event Title</strong> <span style={{ fontSize: '.8rem' }}>*Creates slug for event listing</span>{' '}
              <br />
              <Form.Group>
                <TextField
                  name="headline"
                  formik={formik}
                  value={formik.values.headline}
                  onChange={formik.handleChange}
                />
              </Form.Group>
            </Form>
          </Modal.Content>
          <Modal.Actions>
            <Button color="black" onClick={() => setOpen(false)}>
              Cancel
            </Button>
            <Button
              content="Submit"
              disabled={!formik.isValid}
              labelPosition="left"
              icon="save"
              onClick={formik.handleSubmit}
              positive
            />
          </Modal.Actions>
        </Modal>
      )}
    </Formik>
  );
};

const mapStateToProps = state => ({
  sites: selectors.admin.cultureMapSiteOptions(state),
});

const mapDispatchToProps = dispatch => ({
  getSites: bindActionCreators(actions.admin.getSites, dispatch),
  addNewsItem: bindActionCreators(actions.content.addNewsItem, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddEventModal);
